import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import moment from 'moment';
import { get } from 'lodash';

class ReleaseDateWarning extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
	}
	
	checkEarlyReleases(firstDataDate){		
		let earlyReleases = 0;    
		const { stats } = this.props;
		const filtered = get(stats, 'multiMetadata', []);
		for(let entity of filtered) {
			if(moment(entity.releaseDate).isBefore(firstDataDate))
				earlyReleases++;
		}
		return earlyReleases;
	}



	render (){
		const { filter, user } = this.props;
		const firstData = get(user, 'user.first_data_date');
		const firstDataDate = moment(firstData);
		const startDate = moment(get(filter, 'global.dateStart'))
		if(startDate.isAfter(firstDataDate))
			return null;
			
		const earlyReleases = this.checkEarlyReleases(firstDataDate);
		if(earlyReleases == 0)
			return null;	

		return <div className="missing-data-warning-holder">
			<div className="missing-data-warning">
				<strong>Note: </strong>
				{earlyReleases == 1 ? 'an entity from your filter was' : `${earlyReleases} entities from your filter were`}   released before {firstData} which is your earliest data collection date.
			</div>
		</div>
	}
}

function mapStateToProps(state) {
	return {
		filter: state.filter,
		user: state.user,
		stats: state.stats
	} 
}

export default connect(mapStateToProps)(ReleaseDateWarning)